import * as angular from "angular";
import {IController} from "angular";

export class bringozTimelineLogsTableCtrl implements IController {
  timeline: any;

  constructor() {
  }

  $onInit() {
  }

  $onChanges(changes) {
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozTimelineLogsTable', {
    bindings: {
      timeline: '<',
      isScrollable: '<?'
    },
    template: require('./bringoz-timeline-logs-table.html').default,
    controller: bringozTimelineLogsTableCtrl
  });
